<!-- .block-products-carousel -->
<div
    class="block block-products-carousel block-products-carousel--has-items"
    [attr.data-layout]="'grid-4'"
>
    <div class="container">
        <app-block-header [header]="header"></app-block-header>
        <div class="row">
            <div *ngFor="let product of products" class="block-products-carousel__cell col-sm-6 col-lg-2 col-md-3">
                <app-product-card [product]="product"></app-product-card>
            </div>
        </div>
    </div>
</div>
